module.exports = "https://cdn.hellotech.com/client-assets/female-tech-remote_65a21f1cb85d9498672147f89fbc0cc5.png";